import styled from "styled-components"
export default styled.div`
  position: relative;
  margin: 0.1em 0;
`